import { render, staticRenderFns } from "./ModalGiftBoxFormatQuery.vue?vue&type=template&id=65fc01be&scoped=true&"
import script from "./ModalGiftBoxFormatQuery.vue?vue&type=script&lang=js&"
export * from "./ModalGiftBoxFormatQuery.vue?vue&type=script&lang=js&"
import style0 from "./ModalGiftBoxFormatQuery.vue?vue&type=style&index=0&id=65fc01be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc01be",
  null
  
)

export default component.exports